export default {
  loading: false,
  allReviewsTotalCount: null,
  selectedItems: [],
  allItemsSelected: false,
  data: [],
  isAiReplyInProgress: null
};
